import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import { withStyles } from '@material-ui/core/styles';
import Transition from './Transition';
import FormComponent from '../FormComponent';
import GasBuddyPricesContainer from '../../containers/reports/GasBuddyPrices';
import UpIcon from '@material-ui/icons/ArrowDropUp';
import DownIcon from '@material-ui/icons/ArrowDropDown';
import EnhancedTable from '../table/EnhancedTable';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 20px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		// maxWidth : '100%',
		// width: 800,
		//maxWidth: '98%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	submitButton: {
		fontSize: 16,
		borderRadius: '100px',
		padding: '15px 20px',
		textTransform: 'uppercase',
		marginRight: 10,
	},
	addInputButton: {
		borderRadius: '100px',
		marginTop: 20,
	},
	attachment: {
		position: 'absolute',
		width: '100%',
		height: '100%',
		border: '1px solid #ddd',
	},
	emailBody: {
		border: '1px solid #ddd',
	},
	invoiceDocuments: {
		display: 'flex',
		flexWrap: 'wrap',
		alignContent: 'stretch',
		justifyContent: 'space-between',
		marginTop: 20,
	},
	invoicePage: {
		width: '33%',
		padding: 5,
		boxSizing: 'border-box',
	},
	invoicePageImg: {
		width: '100%',
		height: '100%',
		border: '1px solid #ddd',
	},
	pageSection: {
		borderBottom: '2px dashed #ccc',
		marginBottom: 30,
		paddingBottom: 30,
	},
	newPrices: {
		padding: 10,
	},
	reportedDateTime: {
		fontWeight: 200,
		color: '#666',
		whiteSpace: 'nowrap',
	},
	upDownIcon: {
		marginTop: -9,
		bottom: -9,
		width: 28,
		height: 28,
		position: 'relative',
	},
});

class SaveRetailPriceParseResults extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			apiParseResults: undefined,
			formFieldError: {},
			isSaving: false,
			savingStatus: undefined,
			isUpdate: false,
			savingSuccessful: false,
		};
	}

	handleClose = () => {
		this.setState(
			{
				isSaving: false,
				savingSuccessful: false,
				cost: '',
				description: '',
			},
			this.props.onClose
		);
	};

	handleSave = () => {
		const { showErrors, bulkAddGasBuddyPrices, apiParseResults, daysToLockPrice } = this.props;

		const { stationIdsAndPrices } = apiParseResults;
		if (_.isEmpty(stationIdsAndPrices)) {
			return showErrors(['stationIdsAndPrices is empty']);
		}

		const params = { stationIdsAndPrices };
		if (daysToLockPrice && parseInt(daysToLockPrice)) {
			const d = parseInt(daysToLockPrice);
			params.lockedUntilDateTime = moment().add(d, 'days').utc().format('YYYY-MM-DD HH:mm:ss');
		}

		bulkAddGasBuddyPrices({
			params,
		});
	};

	render() {
		const { classes, open, apiParseResults, fullScreen } = this.props;
		if (!apiParseResults) {
			return null;
		}

		const { stationIdsAndPrices, collections } = apiParseResults;
		const { stationCollection } = collections;
		const stationLookup = _.keyBy(stationCollection, 'stationId');

		// table
		const cols = [
			{ sortId: 'stationDisplay', displayId: 'stationDisplay', label: 'Station' },
			{ sortId: 'e85Price', displayId: 'e85Price', label: 'New Price' },
			{
				sortId: 'latestDisplay',
				displayId: 'latestDisplay',
				label: 'Current Price (Price to replace)',
			},
			{ sortId: 'absDiff', displayId: 'diffDisplay', label: 'Diff' },
		];
		const rows = stationIdsAndPrices.map((stationIdsAndPrice) => {
			const { stationId, e85Price, latestE85Price, latestReportedDateTime } = stationIdsAndPrice;

			const station = stationLookup[stationId] || { number: '', name: 'Missing' };

			const diff = _.round(e85Price - latestE85Price, 3);
			let diffIcon = '';
			if (diff > 0) {
				diffIcon = <UpIcon className={classes.upDownIcon} />;
			} else if (diff < 0) {
				diffIcon = <DownIcon className={classes.upDownIcon} />;
			}

			return {
				key: stationId,
				stationDisplay: `${station.number} - ${station.name}`,
				e85Price,
				latestDisplay: (
					<>
						{latestE85Price}
						<div className={classes.reportedDateTime}>
							{moment(latestReportedDateTime).format('M/D h:mm a')}
						</div>
					</>
				),
				diffDisplay: (
					<>
						{diffIcon} {Math.abs(diff)}
					</>
				),
			};
		});

		return (
			<Dialog
				maxWidth="lg"
				fullScreen={fullScreen}
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{ paper: classes.dialogPaper }}
				fullWidth={true}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>Retail Prices Parse Result</DialogTitle>
					<DialogContent>
						<div className={classes.newPrices}>
							<EnhancedTable columns={cols} rows={rows} isDense={true} />
						</div>
					</DialogContent>
					<DialogActions>
						<div style={{ fontWeight: 800, fontSize: '120%' }}>Everything look correct?</div>
						<Button
							variant="contained"
							onClick={this.handleSave}
							className={classes.submitButton}
							color="primary"
						>
							Yes, Import Retail Prices
						</Button>
						<Button onClick={this.handleClose}>Cancel</Button>
					</DialogActions>
				</div>
			</Dialog>
		);
	}
}

SaveRetailPriceParseResults.propTypes = {
	apiParseResults: PropTypes.object,
	bulkAddGasBuddyPrices: PropTypes.func.isRequired,

	fullScreen: PropTypes.bool.isRequired,
	classes: PropTypes.object.isRequired,
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	daysToLockPrice: PropTypes.number,
};

export default _.flow([withStyles(styles), withMobileDialog(), GasBuddyPricesContainer])(
	SaveRetailPriceParseResults
);
